import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const fetchRejections = (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    insurance_name,
    insurance_ids,
    status,
    dos_from,
    dos_to,
    resubmit_date_from,
    resubmit_date_to,
    order_by,
  } = filter;

  if (account_id === 0) {
    return false;
  }

  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
  let firstName = first_name ? `&first_name=${first_name}` : "";
  let lastName = last_name ? `&last_name=${last_name}` : "";
  let DOB = dob ? `&dob=${dob}` : "";
  let insuranceName = insurance_name ? `&insurance_name=${insurance_name}` : "";
  let insuranceIds = "";
  if (insurance_ids.length > 0) {
    insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
  }
  let Status = status ? `&status=${status}` : "";
  let dosFrom = dos_from ? `&dos_from=${dos_from}` : "";
  let resubmitDateFrom = resubmit_date_from ? `&resubmit_date_from=${resubmit_date_from}` : "";
  let resubmitDateTo = resubmit_date_to ? `&resubmit_date_to=${resubmit_date_to}` : "";
  let dosTo = dos_to ? `&dos_to=${dos_to}` : "";

  try {
    const response = axios.get(`${apiServicesUrl}/rejection/rejections?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${firstName}${lastName}${DOB}${insuranceName}${insuranceIds}${Status}${dosFrom}${dosTo}${resubmitDateFrom}${resubmitDateTo}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const addRejections = async (formData) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/rejection/create`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const editRejections = async (formData) => {
  try {
    const response = await axios.put(`${apiServicesUrl}/rejection/update`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const changeStatusRejections = async (formData) => {
  try {
    const response = await axios.put(`${apiServicesUrl}/rejection/status-change`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const importRejections = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${apiServicesUrl}/rejection/bulk-upload`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteRejectionData = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(`${apiServicesUrl}/rejection/delete?account_id=${account_id}&location_id=${location_id}&id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteBulkRejectionData = async (deleteData) => {
  try {
    const response = await axios.delete(`${apiServicesUrl}/rejection/bulk-delete`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
      data: deleteData,
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const exportAllRejections = async (filter) => {
  const {
    account_id,
    location_id,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    insurance_name,
    insurance_ids,
    status,
    dos_from,
    dos_to,
    resubmit_date_from,
    resubmit_date_to,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let firstName = first_name ? `&first_name=${first_name}` : "";
    let lastName = last_name ? `&last_name=${last_name}` : "";
    let DOB = dob ? `&dob=${dob}` : "";
    let insuranceName = insurance_name ? `&insurance_name=${insurance_name}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }
    let Status = status ? `&status=${status}` : "";
    let dosFrom = dos_from ? `&dos_from=${dos_from}` : "";
    let resubmitDateFrom = resubmit_date_from ? `&resubmit_date_from=${resubmit_date_from}` : "";
    let resubmitDateTo = resubmit_date_to ? `&resubmit_date_to=${resubmit_date_to}` : "";
    let dosTo = dos_to ? `&dos_to=${dos_to}` : "";

    return axios.get(`${apiServicesUrl}/rejection/export-all?account_id=${account_id}&location_id=${location_id}&page=1&per_page=${per_page}${searchParam}${firstName}${lastName}${DOB}${insuranceName}${insuranceIds}${Status}${dosFrom}${dosTo}${resubmitDateFrom}${resubmitDateTo}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const exportRejections = async (data) => {
  try {
    const response = await axios.post(`${apiServicesUrl}/rejection/export`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      }
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const notifyPracticeData = async (notifyData) => {
  try {
    console.log(notifyData);
    
    const response = await axios.post(`${apiServicesUrl}/rejection/notify`, notifyData, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      }
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getRejectionOverview = async (props) => {
  const { location_id, account_id } = props;
  
  if (account_id === 0) {
    return false;
  }
  try {
    const response = await axios.get(`${apiServicesUrl}/rejection/overview?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
